<template>
    <div id="home_page_map"></div> 
</template>
<script>
    import http from '@/api/cardData'
    import Bus from '@/utils/Bus.js'
    import echarts from 'echarts';
    import geoData from '../map-data/get-geography-value.js';
    import allData from '../index.js'
    export default {
        name: 'homeMap',
        data(){
             return{
                 dataItem:[],
                 mapRangeList:[],//地图范围区间数据
                 typeArr:[null,'appointTimeNum','yesterdayNum','monthNum','quarterNum','yearNum','totalNum'],
             }
        },
        props: {
            cityData: Array,
            time:Array,
            dataType:{
                type:String,
                default:'6',
            },
            title:Number,
        },
        watch:{
            'dataType':function(value,oldValue){
                this.initData();
            },
            '$store.state.app.tab':function(value,oldValue){
                this.initData();
            },
        },
        computed: {
            'allTab':function(){
                return this.$store.state.app.tab
            },
            'titleArr':function(){
                return this.$store.state.app.titleArr
            }
        },
        mounted() {
            var convertData = function(data) {
                let res = [];
                let len = data.length;
                for (var i = 0; i < len; i++) {
                    var geoCoord = geoData[data[i].name];
                    if (geoCoord) {
                        res.push({
                            name: data[i].name,
                            value: geoCoord.concat(data[i].value)
                        });
                    }
                }
                return res;
            };
            this.initData();
        },
        methods: {
            initData() {
                    //对数据进行处理
                    this.initCanvas(this.title);
            },
            initCanvas(e) {
                //e为true代表是切换时间
                let that = this;
                let mapData={
                    title: {
                        text: '',
                        subtext: ''
                    },
                    dataRange: {
                        x: 'left',
                        y: '80px',
                        splitList: [{
                            start:0,
                            end:50000,
                        },{
                            start:50000,
                            end:100000,
                        },{
                            start:100000,
                            end:200000,
                        },{
                            start:200000,
                            end:400000,
                        },{
                            label:'400000以上',
                            start:400000
                        }],
                        color: ['#0B65BC','#3289DC', '#5FAEF8', '#94CBFF','#E7E7E7' ],
                    },
                    tooltip: {
                        borderWidth: 1,
                        padding: 10,
                        textStyle: {
                            color: '#ffffff'
                        },
                        formatter: function(params) {
                            let data=params.data;
                            //if(!data||(data&&!data.appointTimeNum))return false;
                            if(data&&data.value){
                              return `  <div style='font-size:14px;font-weight:500;'>${data.name}</div>
                                    <div class="color3">${data.value}</div>    
                                    `;  
                            }else{
                                return '暂无数据';
                            }
                            
                        },
                        extraCssText: 'width: 150px'
                    },
                    series: [{
                        name: '',
                        type: 'map',
                        mapType: 'china',
                        mapLocation: {
                            x: 'left'
                        },
                        zoom: 1.2,
                        selectedMode: 'multiple',
                        itemStyle: {
                            normal: {
                                label: {
                                    show: false,
    
                                },
                                areaColor: '#e7e7e7',
                                borderColor: '#ffffff'
                            },
                            emphasis: {
                                areaColor: '#00dcbb',
                                label: {
                                    show: false
                                }
                            }
                        },
                        data:[]
                    }],
                    animation: false
                }
                mapData.series[0].data=allData.list;
                mapData.title.text='货运平台入网车辆数统计 -截止2018年12月31日'
                var map = echarts.init(document.getElementById('home_page_map'));
                const chinaJson = require('../map-data/china.json');
                echarts.registerMap('china', chinaJson);
                map.setOption(mapData);
                window.addEventListener('resize', function() {
                    map.resize();
                });
            }
        }
    };
</script>
<style scoped>
#home_page_map{
    width:calc(100% - 10px);
    height:100%;
}
</style>

